"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var environment_1 = require("../../environments/environment");
var paystub_filter_1 = require("./paystub.filter");
var api_service_1 = require("../shared/api.service");
var PaystubFilterService = /** @class */ (function () {
    function PaystubFilterService(http) {
        this.http = http;
        this.baseUrl = environment_1.environment.serverUrl;
        this.nextUris = {};
    }
    PaystubFilterService.prototype.getFilters = function (filterType, search) {
        var _this = this;
        if (search === void 0) { search = null; }
        var params = new http_1.HttpParams();
        params = params.set('page_size', '6');
        if (search) {
            params = params.set('search', search);
        }
        var filtersUrl = this.baseUrl + 'expenses/' + filterType + '/';
        return this.http.get(filtersUrl, {
            headers: api_service_1.requestHeaders(),
            params: params
        }).pipe(operators_1.map(function (res) { return _this.extractData(filterType, res); }), operators_1.catchError(api_service_1.handleError));
    };
    PaystubFilterService.prototype.getNext = function (filterType) {
        var _this = this;
        if (this.nextUris[filterType]) {
            return this.http.get(this.nextUris[filterType], { headers: api_service_1.requestHeaders() }).pipe(operators_1.map(function (res) { return _this.extractData(filterType, res); }), operators_1.catchError(api_service_1.handleError));
        }
        else {
            return null;
        }
    };
    PaystubFilterService.prototype.extractData = function (filterType, res, condensed) {
        if (condensed === void 0) { condensed = false; }
        var resObj = res;
        this.nextUris[filterType] = resObj['next'];
        var body = resObj['results'];
        if (body) {
            return body.map(function (filter) {
                return new paystub_filter_1.PaystubFilter(filter);
            });
        }
        else {
            return {};
        }
    };
    return PaystubFilterService;
}());
exports.PaystubFilterService = PaystubFilterService;
